import { Stack } from "@mui/material";
import { EventStatusPill } from "components/layout/event/EventStatusPill";
import { eventCardDate } from "models/Event";
import { Link } from "react-router-dom";
import { Sx } from "utils/sx";
import { EventCard } from "./eventCard/EventCard";
import { EventCardTopLabel } from "./eventCard/EventCardTopLabel";
import { EventCardMainSection } from "./eventCard/EventCardMainSection";
import { EventCardOrganisation } from "./eventCard/EventCardOrganisation";
import { EventCardTitle } from "./eventCard/EventCardTitle";
import { RecentlyViewedEvent } from "./useRecentlyViewed";
import { trackClick, trackingCategory } from "utils/tracking";


export const RecentlyViewedEventCard: React.FC<{item: RecentlyViewedEvent, sx?: Sx}> = ({ item, sx }) => {
    return <Link to={`/events/${item.data.id}`}
                 aria-label={item.data.name}
                 onClick={trackClick("Event card", trackingCategory.recentlyViewed)}>
        <EventCard sx={sx}>
            <EventCardMainSection status={item.data.status} sx={{ flex: 1 }}>
                <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                    <EventCardTopLabel date={eventCardDate(item.data, { shortFormat: true })} />
                    <EventStatusPill status={item.data.status} />
                </Stack>
                <EventCardTitle title={item.data.name} />
            </EventCardMainSection>
            <EventCardOrganisation organisation={item.data.organisation} logo={true} status={item.data.status} />
        </EventCard>
    </Link>;
};
